import { Box } from '@mui/material';
import { LandingNav } from './LandingNav';
import { Hero } from './Hero';
import { Features } from './Features';
import { ForManagement } from './ForManagement';
import { ForResidents } from './ForResidents';
import { HowItWorks } from './HowItWorks';
import { ContactCta } from './ContactCta';
import { LandingFooter } from './LandingFooter';

// Public product-introduction page served at "/". No auth: it sits outside
// ProtectedLayout, so it never triggers an auth check or an API call.
export function LandingPage() {
  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh' }}>
      <LandingNav />
      <Hero />
      <Features />
      <ForManagement />
      <ForResidents />
      <HowItWorks />
      <ContactCta />
      <LandingFooter />
    </Box>
  );
}
